import { render, staticRenderFns } from "./PlanQuestionTwo.vue?vue&type=template&id=16531b2c&scoped=true"
import script from "./PlanQuestionTwo.vue?vue&type=script&lang=js"
export * from "./PlanQuestionTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16531b2c",
  null
  
)

export default component.exports